/*! @license Firebase v4.3.0
Build: rev-bd8265e
Terms: https://firebase.google.com/terms/ */

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.XhrIoPool = undefined;

var _xhrio_network = require('./xhrio_network');

/**
 * Factory-like class for creating XhrIo instances.
 */
var XhrIoPool = function () {
    function XhrIoPool() {}
    XhrIoPool.prototype.createXhrIo = function () {
        return new _xhrio_network.NetworkXhrIo();
    };
    return XhrIoPool;
}(); /**
     * Copyright 2017 Google Inc.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *   http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     */
exports.XhrIoPool = XhrIoPool;
//# sourceMappingURL=xhriopool.js.map



//////////////////
// WEBPACK FOOTER
// /home/kepler/code/github/expense-manager-firebase/~/firebase/storage/implementation/xhriopool.js
// module id = ../../../../firebase/storage/implementation/xhriopool.js
// module chunks = 3